import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { IMesUser } from '@shared/services/mesuser.service';
import { IItemOperation } from '@shared/services/production-data.service';
import { IProductionNotePostRequest, ProductionNoteService } from '@shared/services/production-note.service';

@Component({
	selector: 'app-terminal-create-production-note-dialog',
	templateUrl: './terminal-create-production-note-dialog.component.html',
	styleUrl: './terminal-create-production-note-dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class TerminalCreateProductionNoteComponent implements OnInit {
	@Input() itemOperation: IItemOperation;
	@Input() employees: IMesUser[];
	@Output() created: EventEmitter<any> = new EventEmitter();
	form: FormGroup;
	loading: boolean;
	httpError: string;
	availableSequenceNumbers: number[];

	constructor(
		public dialogRef: MatDialogRef<TerminalCreateProductionNoteComponent>,
		private fb: FormBuilder,
		private productionNoteService: ProductionNoteService,
	) {}

	ngOnInit(): void {
		this.availableSequenceNumbers = this.itemOperation?.items?.map((item) => item.sequenceNumber);
		this.initializeForm();
	}

	initializeForm(): void {
		this.form = this.fb.group({
			sequenceNumber: [this.availableSequenceNumbers[0], [Validators.required]],
			employee: [null, [Validators.required, (control: { value: string }) => (!control.value || !this.employees || this.employees.some((employee) => employee.alias === control.value) ? null : { employeeNotFound: true })]],
			note: ['', [Validators.required]],
		});
	}

	onSave() {
		if (!this.form.valid) return;

		if (this.loading) return;

		this.loading = true;

		const { sequenceNumber, employee, note } = this.form.getRawValue() as {
			note: string;
			employee: string;
			sequenceNumber: number;
		};

		const itemAlias = this.itemOperation.alias;
		const batchId = this.itemOperation.batchId;

		const createRequest: IProductionNotePostRequest = {
			note,
			itemAlias,
			sequenceNumber,
			createdBy: employee,
			batchId,
		};

		this.productionNoteService.create(createRequest).subscribe({
			next: () => {
				this.created.emit();
				this.dialogRef.close();
			},
			error: (errorResponse) => {
				this.httpError = `${errorResponse.status}`;
				this.loading = false;
			},
		});
	}

	onCancel = () => this.dialogRef.close();

	get controls() {
		return this.form.controls;
	}
}
